var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "filter_svg__path-1",
    d: "M0 0h24l-9.818 15.094V24l-4.364-3v-5.906z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_svg__icons-badges-variations",
    transform: "translate(-416 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_svg__icons/filter",
    transform: "translate(416 314)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "filter_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filter_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filter_svg__path-1",
    id: "filter_svg__Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "filter_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#filter_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  })))))));
};
export default SvgFilter;